module.exports = __webpack_public_path__ + "static/pic01-f8f69c09683acb48e03db463673b067e.jpg";